import React from 'react';

const TabbedContent = ({title, children}) => {
  return (
    <div className="TabbedContent">
      {React.Children.only(children)}
    </div>
  );
};

export default TabbedContent;



// WEBPACK FOOTER //
// ./src/components/TabbedContent.js